export interface ExcSummary {
  id: number; ref: string; type: string; title: string;
  amount: number; currency: string; entity: string; severity: string;
  description?: string; department?: string; vendor_name?: string;
  action_count?: number; actions_closed?: number; resolution_status?: string;
}

export interface ActionItem {
  id: number; exception_id: number;
  action_type: string; action_label: string; action_source: string;
  current_department: string; current_role: string; current_level: string;
  status: string; status_reason: string | null;
  resolution_option_id: string | null; resolution_confidence: number | null;
  proposed_je: any; final_je: any;
  je_id: number | null; je_status: string | null;
  transfer_context: string | null;
  prior_findings: Array<{ owner: string; department: string; finding: string; timestamp: string }> | null;
  sla_hours: number;
  due_at: string | null; started_at: string | null; closed_at: string | null;
  created_at: string | null;
  is_overdue?: boolean;
  exception: ExcSummary;
  transfers?: TransferRecord[];
  ai_resolution?: { confidence: number | null; recommendation: string | null; detail: any; action: string | null };
  sil_score?: number | null;
  ai_diagnosis?: { confidence: number | null; reasoning: string | null; standards_cited: string[]; proposed_je: any };
  standards_cited?: string[];
  counterparty_label?: string;
  // Cascade (S38A)
  cascade_authority?: string;
  cascade_level?: number;
  flagged_by_reviewer?: boolean;
  approval_level_required?: number;
  review_context?: { review_chain: Array<{ level: string; reviewer: string; department: string; timestamp: string; notes: string; flagged: boolean }> };
}

export interface TransferRecord {
  id: number; action_id: number;
  from_department: string; from_role: string; from_level: string;
  to_department: string; to_role: string; to_level: string;
  transfer_type: string; transfer_reason: string;
  prior_findings: any; transferred_at: string; transferred_by: string;
}

export interface Stats {
  pending: number; in_review: number; completed: number;
  overdue: number; sla_compliance: number; total: number;
}

export const SEV: Record<string, { color: string; bg: string }> = {
  critical: { color: '#ef4444', bg: 'rgba(239,68,68,0.1)' },
  high: { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)' },
  medium: { color: 'var(--navy-700)', bg: 'var(--accent-subtle)' },
  low: { color: 'var(--positive)', bg: '#dcfce7' },
};

export const DEPT_OPTIONS = [
  'accounts_payable', 'accounts_receivable', 'tax_compliance', 'internal_controls',
  'treasury', 'intercompany', 'payroll', 'procurement', 'general_ledger',
  'fpa', 'credit_risk', 'financial_systems', 'cfo_office',
];

export const labelStyle: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 4 };
export const inputStyle: React.CSSProperties = { width: '100%', padding: 8, background: 'var(--bg-surface)', border: '1px solid var(--bg-border)', borderRadius: 6, color: 'var(--text-primary)', fontSize: 12 };
